import { useTranslation } from "react-i18next";
import { GraduationCap } from "lucide-react";
import { normalizeEducation } from "@/features/talent/utils";
import { EducationEntry } from "./Education/EducationEntry";

interface TalentEducationViewProps {
  profile: any;
}

export function TalentEducationView({ profile }: TalentEducationViewProps) {
  const { t } = useTranslation(["talent", "common"]);

  // Normalize education data using the existing utility
  const { entries: educationItems } = normalizeEducation(profile.education);

  if (!educationItems.length) {
    return (
      <div className="text-center p-8 text-gray-500 bg-white rounded-lg border border-dashed">
        <GraduationCap className="mx-auto h-12 w-12 text-gray-300 mb-3" />
        <p>{t("common:no_data_available")}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-4xl">
      <div className="space-y-6">
        <h3 className="text-lg font-semibold flex items-center gap-2 text-gray-900">
          {t("talent:education.title")}
        </h3>

        <div className="relative pl-8 space-y-8 before:absolute before:left-3 before:top-2 before:bottom-0 before:w-0.5 before:bg-gray-200">
          {educationItems.map((edu: any, index: number) => (
            <EducationEntry key={edu.id || index} edu={edu} />
          ))}
        </div>
      </div>
    </div>
  );
}
